{
	"errorPage.404.button": "Vissza a Kezdőlapra",
	"errorPage.404.code": "404-es hiba",
	"errorPage.404.description": "Sajnáljuk, de a keresett oldal nem található, vagy máshová helyezték.",
	"errorPage.404.title": "Az oldal nem található...",
	"errorPage.network.description": "Nem tudtuk betölteni az oldalt. Kérjük, ellenőrizze az internetbeállításait, majd próbálja meg újra.",
	"errorPage.network.title": "Hiba történt...",
	"global.refreshButton": "Frissítés",
	"global.toast.error.message": "Hiba történt; kérjük, próbálja újra.",
	"global.toast.error.title": "Hiba"
}
